/**
 * @fileoverview Implements a DefaultMap class that extends the standard Map, providing automatic generation of default values when accessing non-existent keys. This utility allows for easy initialization of map entries with a custom default value generation strategy.
 */

export class DefaultMap<K, V> extends Map<K, V> {
  private defaultValue: () => V

  constructor(defaultValue: () => V, entries?: readonly (readonly [K, V])[] | null) {
    super(entries)
    this.defaultValue = defaultValue
  }

  get(key: K): V {
    if (!this.has(key)) {
      const value = this.defaultValue()
      this.set(key, value)
      return value
    }
    return super.get(key)!
  }
}
